import axios from 'axios';
import {
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  DEVICE_COMPATIBLE_CHECK,
  DEVICE_COMPATIBLE_FLAG,
  DEVICE_GO_BACK_FLAG,
  SET_SELECTED_MDN,
  SET_SELECTED_MTNS
} from '../constants';

import httpClient, { getHttpClientRequest, postHttpClientRequest, isUnAuth } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';

export const getSections = (postData,props) => dispatch => {
  dispatch(asyncFetch());

  const onSuccess = response => {
    dispatch(asyncFetchSuccess(response.data));

    if(response?.data?.body?.data?.domesticConfirmation){
      props.ReviewActions.setisReviewLoadValue(true);
      props.remarksActions.setRemarksLoad(true);

      props.history.push("/itpconfirmation");
      props.TravelDateActions.setSelectedTravelDateValue({});
    }
  };

  const onError = error => {
    dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {
    var axConfig = {
      headers: { pageName: "deviceSelection", subServiceName: "deviceSelection" }
    };
    let sApiUrl = isUnAuth() ? apiUrl().itptravelDevicesUrl_ua : apiUrl().itptravelDevicesUrl;
    if (sApiUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(sApiUrl, axConfig);
    } else {
      return postHttpClientRequest(
        sApiUrl,
        postData,
        axConfig
      );
    };
  };
  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp);
      }
    })
    .catch(onError);
};


export const asyncFetch = urlParams => ({
  type: ASYNC_FETCH,
  urlParams
});
export const asyncFetchSuccess = msResp => ({
  type: ASYNC_FETCH_SUCCESS,
  msResp
});
export const asyncFetchFailed = err => ({
  type: ASYNC_FETCH_FAILURE,
  err
});
export function deviceCompatibleBolleanAction(BoolenValue) {
  return {
    type: DEVICE_COMPATIBLE_FLAG,
    flag: BoolenValue,
  };
}

export function deviceGoBackAction(data) {
  return {
    type: DEVICE_GO_BACK_FLAG,
    flag: data,
  };
}
function deviceCompatibleCheckDataAction(data) {
  return {
    type: DEVICE_COMPATIBLE_CHECK,
    data,
  };
}
export const deviceCompatibleCheck = (props, postData) => (dispatch) => {

  const onSuccess = response => {
    if (response && response.data && response.data.body && response.data.body.data && response.data.body.data.internationalPlan && !response.data.body.data.internationalPlan.deviceCompatible && response.data.body.data.internationalPlan.deviceNotCompatible) {
      dispatch(deviceCompatibleBolleanAction(true));
      dispatch(deviceCompatibleCheckDataAction(response.data.body.data.internationalPlan));
    } else {
      props.history.push({ pathname: response.data.body.data.internationalPlan.redirectUrl });
      //window.location.hash = response.data.body.data.redirectUrl;
    }
  };

  const onError = error => {
   // dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {
    var axConfig = {
      headers: { pageName: "deviceSelection", subServiceName: "deviceSelection" }
    };
    let sApiUrl = apiUrl().itptDevicesCompatible_ua;
    if (sApiUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(sApiUrl, axConfig);
    } else {
      return postHttpClientRequest(
        sApiUrl,
        postData,
        axConfig
      );
    };
  };
  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp);
      }
    })
    .catch(onError);

};

export const setSelectedMdnValue = data => ({
  type: SET_SELECTED_MDN,
  data
});


export const setSelectedMtnsValue = data => ({
  type: SET_SELECTED_MTNS,
  data
});